import React from 'react';
import { useEventDetails } from '../../../hooks/useEventDetails';
import { useEventContext } from '../../contexts/EventContext';
import { CustomPage } from './CustomPage';
import { V1CustomPage } from '../../v1/components/V1CustomPage';

/**
 * Wrapper component that routes to V1 or V2 custom page based on event type
 */
export const CustomPageWrapper: React.FC = () => {
  const { eventSlug } = useEventContext();
  const { data: eventDetails } = useEventDetails(eventSlug);

  // Use V1 component for V1 events
  if (eventDetails?.isV1Event) {
    return <V1CustomPage />;
  }

  // Use V2 component for V2 events
  return <CustomPage />;
};